<template>
  <div>
    <nav class=" border p-1 fixed-bottom bg-white ">
      <div class="row">
        <div class="col border-end nav-item text-center">
          <router-link to="/" class="nav-link text-dark" exact>
            O2
          </router-link>
        </div>
        <div class="col border-end nav-item text-center">
          <router-link to="/oxylvl" class="nav-link text-dark" exact>
            Flow Rate
          </router-link>
        </div>
        <div class="col nav-item text-center">
          <router-link to="/knowledge" class="nav-link text-dark" exact>
            အရေးပေါ်
          </router-link>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Menu",
};
</script>

<style>
nav {
  display: inline;

  font-weight: 300;
  font-size: 18px;
}

@media only screen and (max-width: 600px) {
  nav {
    display: block;

    font-weight: 200;
    font-size: 15px;
  }
}
nav.col {
  border-right: 1px solid black !important;
}

a.router-link-active {
  color: white;
  background: rgba(221, 216, 216, 0.822);
  border-radius: 5px;
  box-shadow: 2, 2, 2 #ffffff;
}
</style>
